<div id="order-flow-container">
  <div class="main-container">
      <div class="tab-container">
          <div *ngFor="let tab of tabs" 
              class="tab-item" 
              [class.inactive]="activeTab < tab.id"
              [style.cursor]="activeTab < tab.id ? 'default' : 'pointer'"
              (click)="goToTab(tab.id)">
              <div class="tab-text"><span>{{tab.id}}. </span><span class="tab-text-label-hidden">{{tab.label}}</span></div>
          </div>
      </div>

      <ng-container *ngIf="activeTab === 1">
        <div @slideUp class="tab-content">
          <div class="content-section">
              <div class="title-text">What is Your goal?</div>
          </div>
          <div class="card-row">
              <div *ngFor="let goal of goals" 
                  class="goal-card order-flow-card" 
                  [class.selected]="goal.selected"
                  (click)="selectGoal(goal)">
                  <img *ngIf="goal.selected" src="assets/images/checkmark-circle-black.svg" class="checkmark-icon">
                  <div class="card-content">
                      <div class="card-icon">
                          <img src="{{goal.icon}}">
                      </div>
                      <div class="card-label">{{goal.label}}</div>
                      <div class="goal-description" [innerHTML]="goal.description"></div>
                  </div>
              </div>
          </div>
          <app-orange-button text="Continue" (action)="goToTab(2)" />
          <app-disclaimer></app-disclaimer>
        </div>
      </ng-container>

      <ng-container *ngIf="activeTab === 2">
        <div @slideUp class="tab-content">
          <div class="content-section">
              <div class="title-text">What kind of meals fuel you best?</div>
              <div class="subtitle-text">Your preferences help us personalise your plan, you'll still have full access to every meal on the menu.</div>
          </div>
          <div class="card-grid">
              <div class="card-row card-row-responsive">
                  <div *ngFor="let category of mealCategories" 
                       class="meal-card order-flow-card" 
                       [class.selected]="category.selected"
                       (click)="selectMealCategory(category)">
                      <img *ngIf="category.selected" src="assets/images/checkmark-circle-black.svg" class="checkmark-icon">
                      <div class="card-content">
                          <div class="card-icon">
                              <img [src]="category.icon">
                          </div>
                          <div class="card-label">{{category.name}}</div>
                      </div>
                  </div>
              </div>
          </div>
          <app-orange-button text="Continue" (action)="goToTab(3)" />
          <app-disclaimer></app-disclaimer>
        </div>
      </ng-container>

      <ng-container *ngIf="activeTab === 3">
        <div @slideUp class="tab-content">
          <div class="main-container">
              <div class="title-text">How Many Meals per Day?</div>
              <div class="card-row">
                  <div *ngFor="let meal of mealsPerDay" 
                       class="number-card order-flow-card" 
                       [class.selected]="meal.selected"
                       (click)="selectMealsPerDay(meal)">
                      <img *ngIf="meal.selected" src="assets/images/checkmark-circle-black.svg" class="checkmark-icon">
                      <div class="number-text">{{meal.value}}</div>
                  </div>
              </div>
              <div class="section-divider"></div>
              <div class="title-text">How Many Days per Week?</div>
              <div class="card-row card-row-days">
                <ng-container *ngFor="let day of daysPerWeek">
                  <div *ngIf="!(day.value === 3 && getSelectedMealsPerDay() === 1)"
                       class="number-card order-flow-card" 
                       [class.selected]="day.selected"
                       (click)="selectDaysPerWeek(day)">
                      <img *ngIf="day.selected" src="assets/images/checkmark-circle-black.svg" class="checkmark-icon">
                      <div class="number-text">{{day.value}}</div>
                  </div>
                  </ng-container>
              </div>
              
          </div>
          <app-orange-button text="Continue" (action)="goToTab(4)" />
          <app-disclaimer></app-disclaimer>
        </div>
      </ng-container>

      <ng-container *ngIf="activeTab === 4">
        <div @slideUp class="tab-content">
          <div class="content-section">
              <div class="title-text">Do You Have Any Allergies?</div>
          </div>
          <div class="card-row">
              <div *ngFor="let option of allergyOptions" 
                   class="meal-card order-flow-card" 
                   [class.selected]="option.selected"
                   (click)="selectAllergyOption(option)">
                  <img *ngIf="option.selected" src="assets/images/checkmark-circle-black.svg" class="checkmark-icon">
                  <div class="card-content">
                      <div class="card-label">{{option.label}}</div>
                  </div>
              </div>
          </div>
          <div class="card-row" *ngIf="showAllergiesDialog">
            <app-allergies-dialog style="margin-top: -50px;" [dialog]="false" [showTitle]="false" [preSelectedAllergies]="preSelectedAllergies" (nextAction)="addAllergiesAndGoToOrderSummary($event)"></app-allergies-dialog>
          </div>
          <app-orange-button text="Continue" *ngIf="!showAllergiesDialog" (action)="goToOrderSummary()" />
          <app-disclaimer></app-disclaimer>
        </div>
      </ng-container>
  </div>
</div>